import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import BranchOfficeCard from './BranchOfficeCard';
import BranchOfficeService from '../../../services/BranchOfficeService';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  branchOfficeCard: {
    height: '100%'
  }
}));

const BranchOfficeList = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [branchOffices, setBranchOffices] = useState([]);

  useEffect(() => {
    const foo = async () => {
      const fetchData = await BranchOfficeService.getAll();

      if (fetchData?.code === 200) {
        setBranchOffices(fetchData.data);
      }
    };

    foo();
  }, []);

  const handleOpenSchedule = (branchOfficeId) => {
    navigate(`/app/sucursales/${branchOfficeId}/horario`, { replace: true });
  };

  return (
    <Page
      className={classes.root}
      title="Sucursales"
    >
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
          <Grid
            container
            spacing={3}
          >
            {branchOffices.map((branchOffice) => (
              <Grid
                item
                key={branchOffice.id}
                lg={4}
                md={6}
                xs={12}
              >
                <BranchOfficeCard
                  className={classes.branchOfficeCard}
                  branchOffice={branchOffice}
                  openSchedule={handleOpenSchedule}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box
          mt={3}
          display="flex"
          justifyContent="center"
        >
          <Pagination
            color="primary"
            count={3}
            size="small"
          />
        </Box>
      </Container>
    </Page>
  );
};

export default BranchOfficeList;
